var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10 20c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2Zm2-17.834A2.994 2.994 0 0 0 8 4.99c0 .808.319 1.557.876 2.114l2.97 2.99a2.99 2.99 0 0 0 4.154.072V14c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V8c0-2.61 1.67-4.81 4-5.63V2c0-1.1.9-2 2-2s2 .9 2 2v.166Zm1.26 6.514-2.97-2.99a.973.973 0 0 1-.29-.7c0-.55.44-1 .99-1 .27 0 .52.11.7.29l2.28 2.28 4.27-4.27a.99.99 0 0 1 .7-.29c.55 0 1 .45 1 1 0 .28-.11.53-.3.7l-4.98 4.98a.99.99 0 0 1-1.4 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsUpdated);
export default __webpack_public_path__ + "static/media/notifications-updated.df1e50723c428482d67c672adb86cdf6.svg";
export { ForwardRef as ReactComponent };